import React, { useContext, useEffect, useState } from "react";
import LoadingIcon from "../../images/Loading_icon.gif";
import Swal from "sweetalert2";
import { UrlContext } from "../../contexts/UrlContext";

export default function ViewExistingPPT({ project, expertName }) {
  const [waitingPopup, setWaitingPopup] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const [downloadUrl, setDownloadUrl] = useState("");
  const { API_URL } = useContext(UrlContext);
  useEffect(() => {
    const authToken = localStorage.getItem("accesstoken");
    const projectID = project.project_id;
    const fileName = project.pptExist;
    fetch(
      `${API_URL}view-existingPPT?expertName=${expertName}&projectID=${projectID}&fileName=${fileName}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: authToken,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if ((data.status = "success")) {
          setDownloadUrl(data.download);
          setFileUrl(data.open);
        } else {
          setDownloadUrl(null);
          setFileUrl(null);
        }
      })
      .catch((err) => {});
  }, []);

  return (
    <div className="singleRowPPT">
      <span>{project.pptExist}</span>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "120px",
        }}
      >
        {fileUrl ? (
          <button
            onClick={() =>
              window.open(fileUrl, "_blank", "rel=noopener noreferrer")
            }
            className="btn-default PPT_Exist"
            title="Click to open"
          />
        ) : null}
        {downloadUrl ? (
          <i
            onClick={() =>
              window.open(downloadUrl, "_blank", "rel=noopener noreferrer")
            }
            className="fa-solid fa-download"
            title="Click to download"
          ></i>
        ) : null}
      </div>
      {waitingPopup && (
        <div className="downloadPPT-popup-wrapper">
          <div className="tab-pane fade show downloadPPT-div">
            <center>
              <p style={{ fontSize: "18px" }}>Existing PPT is downloading..</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </div>
  );
}
